import { Alert } from '@creditornot/cb-alert';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { ModalContent, ModalFooter } from '@creditornot/cb-modal';
import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const LeftPanel = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
`;

export const StyledFooter = styled(ModalFooter)`
  display: flex;
  justify-content: space-between;
  padding: 16px;
`;

export const StyledModalContent = styled(ModalContent)`
  padding: 0;
`;

export const SearchContainer = styled.div`
  padding: 12px 16px;
`;

export const VenueListContainer = styled.div`
  padding: 16px;
  height: 350px;
  overflow-y: auto;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Error = styled(Alert).attrs({ variant: 'error' })`
  width: 100%;
  margin: 0 0 16px;
`;

export const LoadingSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-block-start: 40px;
  padding-block-end: 40px;
`;

export const Loading = () => (
  <LoadingSpinnerContainer>
    <Spinner size="large" />
  </LoadingSpinnerContainer>
);

export const NumberSearchResults = styled(T.Body3)`
  color: ${cbSemanticCssVars.textSecondary};
`;

export const EmptyResults = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const EmptyImageWrapper = styled.div`
  margin-block-end: 20px;
  width: 375px;
`;
